import { ViewerEventType, ViewerWebappOpenEvent, ViewerWebappCloseEvent } from '../../types/ViewerEvents.type';
import { ASSET_TYPE } from '../../constants/Constants';
import { browser } from '../../helpers/BrowserHelper';
import { FullscreenHelper } from '../../helpers/FullscreenHelper';
import { IframeHelper } from '../../helpers/IframeHelper';
import { interpolateUrlVariables } from '../../helpers/UrlHelper';
import { ScormMock } from '../../mocks/scorm.mock';
import { TranslationKeys } from '../../types/Translations.type';
import { FullscreenActionBar } from '../FullscreenActionBar';
export class NewWindowPresentationRenderer {
    constructor(assetViewerView, presentation) {
        this.assetViewerView = assetViewerView;
        this.presentation = presentation;
        this.container = null;
        this.isActive = false;
        this.isLoading = false;
        this.isFullscreen = false;
    }
    get url() {
        const pageIndex = (this.presentation.details && this.presentation.details.firstPageIndex) || 0;
        return interpolateUrlVariables(this.presentation.urls[pageIndex], this.config);
    }
    get dimensions() {
        return { width: 400, height: 300 };
    }
    get hasMetaData() {
        return !!this.dimensions;
    }
    get config() {
        return this.assetViewerView.config;
    }
    get translations() {
        return this.assetViewerView.config.TRANSLATIONS;
    }
    load() { }
    render(container) {
        this.container = container;
        return Promise.resolve().then(() => {
            const placeholder = document.createElement('div');
            const wrapper = document.createElement('div');
            const link = document.createElement('div');
            link.classList.add('button-open');
            placeholder.style.width = '100%';
            placeholder.style.height = '100%';
            placeholder.style.backgroundImage = `url(${this.assetViewerView.assetViewerItem.previewUrl})`;
            placeholder.style.backgroundRepeat = 'no-repeat';
            placeholder.style.backgroundPosition = 'center';
            placeholder.style.backgroundSize = 'contain';
            placeholder.style.webkitFilter = 'blur(20px)';
            placeholder.style.transform = 'scale(1.2)';
            wrapper.appendChild(link);
            link.innerHTML = this.translations[TranslationKeys.Open];
            wrapper.style.width = '100%';
            wrapper.style.height = '100%';
            wrapper.style.overflow = 'hidden';
            wrapper.appendChild(placeholder);
            link.onclick = () => {
                if (this.newWindow) {
                    this.newWindow.style.display = 'block';
                    FullscreenHelper.enterFullscreen(this.newWindow);
                    this.isFullscreen = true;
                }
                else {
                    this.renderIframe();
                }
                this.assetViewerView.eventBus.dispatch(new ViewerWebappOpenEvent({ assetViewerItem: this.assetViewerView.assetViewerItem }));
            };
            container.appendChild(wrapper);
        });
    }
    renderIframe() {
        this.isLoading = true;
        // Workaround for mobile safari scroll+overflow issue with iframes
        const wrapper = document.createElement('div');
        wrapper.style.width = '100%';
        wrapper.style.height = '100%';
        wrapper.style.webkitOverflowScrolling = 'touch';
        wrapper.style.background = 'black';
        // iframe scroll hack for mobile safari
        if (browser.ios || (browser.safari && 'ontouchstart' in window)) {
            wrapper.style.overflow = 'auto';
        }
        wrapper.classList.add('iframe-wrapper');
        const iframe = (this.iframe = document.createElement('iframe'));
        iframe.classList.add('av-webapp-iframe');
        wrapper.appendChild(iframe);
        iframe.scrolling = 'yes';
        iframe.onload = onLoad.bind(this);
        iframe.onerror = onError.bind(this);
        iframe.src = this.url;
        this.assetViewerView.config.container.parentNode.appendChild(wrapper);
        this.newWindow = wrapper;
        if (this.assetViewerView.assetViewerItem.type === ASSET_TYPE.SCORM && this.config.SCORM_API_AVAILABLE === false) {
            this.scormMock = new ScormMock();
            this.scormMock.ensureAPI();
        }
        this.iframe.src = this.url;
        this.renderActionBar(wrapper, iframe);
        if (!FullscreenHelper.isFullscreen()) {
            FullscreenHelper.enterFullscreen(wrapper);
        }
        this.isFullscreen = true;
        this.assetViewerView.eventBus.on(ViewerEventType.FullscreenChange, () => {
            if (this.isFullscreen === true && !FullscreenHelper.isFullscreen()) {
                wrapper.style.display = 'none';
                this.isFullscreen = null;
                this.assetViewerView.eventBus.dispatch(new ViewerWebappCloseEvent({ assetViewerItem: this.assetViewerView.assetViewerItem }));
            }
        });
        function onLoad() {
            const config = this.assetViewerView.config;
            // Only do the following on same-origin iframes
            if (this.iframe.contentDocument) {
                IframeHelper.injectShowpadScripts(this.iframe, {
                    iframeUrl: this.url,
                    trackHtmlPageLocation: config.TRACK_HTML_PAGE_LOCATION_ENABLED && this.assetViewerView.assetViewerItem.type === ASSET_TYPE.WEBAPP,
                    showpadJsPath: config.SHOWPAD_JS_PATH,
                    user: config.showpadUser
                });
            }
            this.isLoading = false;
            this.width = 400;
            this.height = 300;
            iframe.onerror = null;
        }
        function onError(error) {
            this.isLoading = false;
            iframe.onload = null;
            iframe.onerror = null;
            this.iframe = null;
        }
    }
    renderActionBar(container, iframe) {
        this.actionBar = new FullscreenActionBar(this.assetViewerView.config, this.assetViewerView.eventBus, this.assetViewerView);
        this.actionBar.render(container, iframe);
    }
    destroy() {
        this.iframe = null;
        if (this.container) {
            this.container.innerHTML = '';
            this.container = null;
        }
    }
    destroyFinal() {
        this.destroy();
    }
}
//# sourceMappingURL=NewWindowPresentationRenderer.js.map